import { useMutation, useQueryClient } from "@tanstack/react-query";
import postsMediaAPI from "../../api/posts-media/api";

export function useDeletePostMedia() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postsMediaAPI.deletePostMedia,
    onSuccess: (data, variables) => {
      // Invalidate and refetch posts media list
      queryClient.invalidateQueries({ queryKey: ["posts-media"] });
    },
    onError: (error) => {
      console.error("Delete post media failed:", error);
    },
  });
}
